import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const tartarSauceBadgeDefinition: BoggleBadgeDefinition = {
  category: 'letters',
  description:
    'Play a 6+ letter word consisting of the same sequence twice',
  iconId: 'tartarSauce',
  id: 'tartarSauce',
  level: 'common',
  lockedReveal: 'reveal',
  name: 'Tartar Sauce',
  points: getBoggleBadgePointsForLevel('common'),
}
